import type { FieldSchema } from '../../../../../schema-types'
import { SECTION_STYLE_FIELDS } from '../../../../lightings/lightings-1/_builder-constants'

/** Content icons the Projukti kit draws (shared names like "shipping" still map onto them). */
export const ICON_OPTIONS = ['truck', 'cash', 'phone', 'shield', 'star', 'heart', 'package', 'check', 'store', 'map-pin', 'mail', 'leaf', 'sparkle', 'clock', 'headset', 'zap', 'award', 'refresh']
  .map(value => ({ label: value.replace('-', ' '), value }))

/** Left-aligned section heading (eyebrow, title, subtitle) shared by Projukti home sections. */
export const headingFields = (defaults: { eyebrow?: string, title?: string, subtitle?: string } = {}): FieldSchema[] => [
  { key: 'eyebrow', label: 'Eyebrow', type: 'localized-string', default: defaults.eyebrow ?? '', help: 'Small line above the title.' },
  { key: 'title', label: 'Title', type: 'localized-string', default: defaults.title ?? '' },
  { key: 'subtitle', label: 'Subtitle', type: 'localized-text', default: defaults.subtitle ?? '' },
]

/** Content point (icon, title, short text) used by the story band and the promises strip. */
export const CONTENT_POINT_SCHEMA: FieldSchema[] = [
  { key: 'icon', label: 'Icon', type: 'icon', default: 'shield', options: ICON_OPTIONS },
  { key: 'title', label: 'Title', type: 'localized-string' },
  { key: 'body', label: 'Text', type: 'localized-text' },
]

/** Pages a home content section can be placed on. */
export const CONTENT_PAGES = ['home', 'shop', 'category', 'categories', 'product', 'cart', 'blog']

export { SECTION_STYLE_FIELDS }
